import React from 'react'
import {
    Box,
    Link,
    Typography,
} from "@mui/material";
import reactLogo from "../../../assets/images/react.png";
import muiLogo from "../../../assets/images/mui.png";

const Footer = () => {
    return ( 
        <Box sx={{p:3, textAlign:'center' }}>
            <Typography variant="h6" color="#B0BEC5" >Built with&nbsp; <img alt="Logo" src={reactLogo} height="18"/> React framework and&nbsp;&nbsp; <img alt="Logo" src={muiLogo} height="18"/><Link href="https://mui.com/material-ui/getting-started/"> &nbsp;&nbsp;Material UI library</Link></Typography>
        </Box>
     );
}
export default Footer;




